import { Node, Edge } from 'reactflow';

/**
 * Tipos de scripts suportados pelo bot
 * Nota: 'variacao' foi removido - a IA gera variações naturalmente
 */
export type ScriptType =
  | 'conteudo'
  | 'mentalidade'
  | 'fatos_produto'
  | 'persona'
  | 'girias'
  | 'abreviacoes'
  | 'emojis';

/**
 * Dados de um nó de script no Flow Canvas
 */
export interface ScriptNodeData {
  scriptType: ScriptType;
  scriptName: string;
  content: string;
  category: string;
  intention?: string;
  lastModified?: Date;
  lineCount?: number;
}

/**
 * Nó de script tipado (React Flow)
 */
export type ScriptNode = Node<ScriptNodeData>;

/**
 * Estado global do Flow Builder
 */
export interface FlowState {
  nodes: ScriptNode[];
  edges: Edge[];
  selectedNode: ScriptNode | null;
}

/**
 * Props do BotFlowBuilder (componente principal)
 */
export interface BotFlowBuilderProps {
  userId: string | null;
}

/**
 * Props do ConfigPanel (painel inferior)
 */
export interface ConfigPanelProps {
  userId: string | null;
  isMinimized: boolean;
  onToggleMinimize: () => void;
}

/**
 * Props do ScriptEditorModal
 */
export interface ScriptEditorModalProps {
  scriptType: ScriptType;
  scriptName: string;
  content: string;
  onSave: (content: string) => Promise<void>;
  onClose: () => void;
  loading?: boolean;
}

/**
 * Cores e gradientes por tipo de script
 * Gírias, Abreviações e Emojis compartilham a mesma cor (Escrita)
 */
export const SCRIPT_COLORS: Record<ScriptType, string> = {
  conteudo: 'linear-gradient(135deg, #6b7280, #4b5563)',
  mentalidade: 'linear-gradient(135deg, #ef4444, #dc2626)',
  fatos_produto: 'linear-gradient(135deg, #f59e0b, #d97706)',
  persona: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
  // Escrita (unificado)
  girias: 'linear-gradient(135deg, #10b981, #059669)',
  abreviacoes: 'linear-gradient(135deg, #10b981, #059669)',
  emojis: 'linear-gradient(135deg, #10b981, #059669)',
};

/**
 * Cores sólidas por tipo (para edges e backgrounds)
 */
export const SCRIPT_SOLID_COLORS: Record<ScriptType, string> = {
  conteudo: '#6b7280',
  mentalidade: '#ef4444',
  fatos_produto: '#f59e0b',
  persona: '#8b5cf6',
  // Escrita (unificado)
  girias: '#10b981',
  abreviacoes: '#10b981',
  emojis: '#10b981',
};

/**
 * Categorias de scripts (para agrupamento visual)
 */
export const SCRIPT_CATEGORIES: Record<string, ScriptType[]> = {
  'Scripts de Conteúdo': ['conteudo'],
  'Mentalidades': ['mentalidade'],
  'Informações do Produto': ['fatos_produto'],
  'Configuração de Persona': ['persona'],
  'Escrita': ['girias', 'abreviacoes', 'emojis'],
};
